import React from 'react';
import { Link } from 'react-router-dom';
import SEO, { SEOPages } from '../components/SEO';

const MentionsLegales = () => {
  return (
    <div className="pt-20">
      <SEO {...SEOPages.mentionsLegales} />
      <section className="py-20">
        <div className="container max-w-4xl mx-auto">
          <div className="glass p-12 rounded-3xl">
            <h1 className="text-4xl font-bold heading-display text-white mb-8">
              Mentions légales
            </h1>

            <div className="space-y-8 text-gray-300">
              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Informations sur l'entreprise</h2>
                <div className="space-y-2">
                  <p><strong className="text-white">Raison sociale :</strong> ATOM Group SA</p>
                  <p><strong className="text-white">Forme juridique :</strong> Société Anonyme (SA)</p>
                  <p><strong className="text-white">Siège social :</strong> c/o Microcity SA, Rue de la Pierre-à-Mazel 39, 2000 Neuchâtel, Suisse</p>
                  <p><strong className="text-white">Téléphone :</strong> +41 32 539 16 27</p>
                  <p><strong className="text-white">Email :</strong> contact@atom-group.ch</p>
                  <p><strong className="text-white">Site web :</strong> https://www.atom-group.ch</p>
                  <p><strong className="text-white">IDE :</strong> CHE-415.883.569</p>
                  <p><strong className="text-white">N° TVA :</strong> CHE-415.883.569 TVA</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Représentants légaux</h2>
                <div className="space-y-2">
                  <p><strong className="text-white">Administrateurs :</strong></p>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    <li>Joël Ott, Président du Conseil d'Administration</li>
                    <li>Quentin Mauron, Administrateur</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Activité et surveillance</h2>
                <p className="mb-4">
                  ATOM Group SA est une société de conseil financier indépendant offrant des services de 
                  consultation en matière d'assurances, fiscalité, prévoyance, investissements et 
                  financement hypothécaire.
                </p>
                <p><strong className="text-white">Assurance responsabilité civile professionnelle :</strong> ATOM Group SA dispose d'une assurance responsabilité civile professionnelle couvrant les risques liés à son activité de conseil financier.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Hébergement et technique</h2>
                <div className="space-y-2">
                  <p><strong className="text-white">Hébergement :</strong> Site hébergé en Suisse</p>
                  <p><strong className="text-white">Conception et développement :</strong> Site développé avec les technologies React, FastAPI et MongoDB</p>
                  <p><strong className="text-white">Certificat SSL :</strong> Site sécurisé par certificat SSL/TLS</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Conditions d'utilisation</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Acceptation des conditions</h3>
                    <p>L'utilisation de ce site web implique l'acceptation pleine et entière des présentes mentions légales et conditions d'utilisation.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Utilisation conforme</h3>
                    <p>L'utilisateur s'engage à utiliser ce site web de manière conforme à la loi et aux présentes conditions, notamment à ne pas :</p>
                    <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                      <li>Utiliser le site à des fins illégales ou non autorisées</li>
                      <li>Tenter de nuire au fonctionnement du site</li>
                      <li>Reproduire, distribuer ou modifier le contenu sans autorisation</li>
                      <li>Usurper l'identité d'une autre personne ou entité</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Responsabilité et garanties</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Responsabilité du contenu</h3>
                    <p>
                      ATOM Group SA s'efforce de maintenir les informations de ce site web exactes et à jour. 
                      Cependant, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des 
                      informations fournies. L'utilisation des informations de ce site web se fait aux risques 
                      et périls de l'utilisateur.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Limitation de responsabilité</h3>
                    <p>
                      ATOM Group SA ne saurait être tenue responsable des dommages directs ou indirects 
                      résultant de l'utilisation de ce site web ou de l'impossibilité de l'utiliser, 
                      sauf en cas de faute intentionnelle ou de négligence grave.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Disponibilité du service</h3>
                    <p>
                      ATOM Group SA s'efforce d'assurer la disponibilité de ce site web 24h/24 et 7j/7, 
                      mais ne peut garantir un accès ininterrompu. Le site peut être temporairement 
                      indisponible pour des raisons de maintenance, mise à jour ou circonstances 
                      indépendantes de notre volonté.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Propriété intellectuelle</h2>
                <p>
                  Le contenu de ce site web (textes, images, graphiques, sons, vidéos, logos, marques, etc.) 
                  est protégé par le droit d'auteur et autres droits de propriété intellectuelle. 
                  Toute reproduction, distribution, modification, transmission ou utilisation commerciale 
                  sans autorisation écrite préalable de ATOM Group SA est strictement interdite.
                </p>
                <p className="mt-2">
                  <strong className="text-white">Marques :</strong> "ATOM Group" et le logo associé sont des marques de ATOM Group SA.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Protection des données personnelles</h2>
                <p>
                  Le traitement des données personnelles collectées via ce site web est régi par notre 
                  <Link to="/confidentialite" className="text-blue-400 hover:text-blue-300 underline"> politique de confidentialité</Link>.
                  ATOM Group SA s'engage à respecter les dispositions de la Loi fédérale sur la protection des données (LPD) 
                  et du Règlement général sur la protection des données (RGPD) de l'UE.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Cookies et technologies similaires</h2>
                <p>
                  Ce site web utilise des cookies et des technologies similaires pour améliorer l'expérience utilisateur, 
                  analyser le trafic et personnaliser le contenu. En continuant à naviguer sur ce site, 
                  vous acceptez l'utilisation de ces technologies conformément à notre politique de cookies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Liens externes</h2>
                <p>
                  Ce site web peut contenir des liens vers des sites externes. ATOM Group SA n'exerce aucun 
                  contrôle sur ces sites et n'assume aucune responsabilité quant à leur contenu, leur disponibilité 
                  ou leurs pratiques en matière de protection des données. L'inclusion de ces liens ne constitue 
                  pas une approbation ou une recommandation de notre part.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Résolution des litiges</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Droit applicable</h3>
                    <p>Les présentes mentions légales sont soumises au droit suisse.</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Juridiction compétente</h3>
                    <p>
                      Tout litige relatif à l'utilisation de ce site web sera de la compétence exclusive 
                      des tribunaux du canton de Neuchâtel, Suisse, sous réserve d'un recours au Tribunal fédéral.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Médiation</h3>
                    <p>
                      En cas de litige, les parties s'efforceront de trouver une solution amiable avant 
                      tout recours judiciaire. ATOM Group SA est membre de l'association professionnelle 
                      des conseillers financiers suisses et accepte la médiation selon les règles de cette association.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Dispositions diverses</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Modification des mentions légales</h3>
                    <p>
                      ATOM Group SA se réserve le droit de modifier ces mentions légales à tout moment. 
                      Les modifications entrent en vigueur dès leur publication sur ce site web. 
                      Il appartient à l'utilisateur de consulter régulièrement cette page.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Nullité partielle</h3>
                    <p>
                      Si une ou plusieurs dispositions des présentes mentions légales étaient déclarées 
                      nulles ou inapplicables, les autres dispositions resteraient pleinement en vigueur.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Contact</h3>
                    <p>
                      Pour toute question concernant ces mentions légales, vous pouvez nous contacter à :
                    </p>
                    <div className="mt-2 ml-4">
                      <p>ATOM Group SA</p>
                      <p>c/o Microcity SA</p>
                      <p>Rue de la Pierre-à-Mazel 39</p>
                      <p>2000 Neuchâtel, Suisse</p>
                      <p>Téléphone: +41 32 539 16 27</p>
                      <p>Email: contact@atom-group.ch</p>
                    </div>
                  </div>
                </div>
              </section>

              <div className="pt-8 border-t border-gray-600">
                <p className="text-sm text-gray-400">
                  Dernière mise à jour : 10 janvier 2025
                </p>
                <p className="text-sm text-gray-400 mt-1">
                  Version 1.2 - Document conforme au droit suisse
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <Link to="/" className="btn-glass btn-primary px-8 py-3 mr-4">
                Retour à l'accueil
              </Link>
              <Link to="/confidentialite" className="btn-glass px-8 py-3">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;